// extracted by mini-css-extract-plugin
export default {"suggestionsContainer":"HJLtJ1","GetItButton":"PpzNaJ","getItButton":"PpzNaJ","businessEmailRow":"e7qgpB","businessEmailGetIt":"MT9mYi","suggestionRowCard":"IN_EOS"};